const SvgCommentGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M5.479 13c-.152.005-.352.125-.479.2l-3.792 2.69a.808.808 0 01-.8.007.788.788 0 01-.408-.686V3.3A2.3 2.3 0 012.3 1h11.4A2.3 2.3 0 0116 3.3v7.4a2.3 2.3 0 01-2.3 2.3H5.479z' />
  </svg>
);

export default SvgCommentGlyph;
